import { render, staticRenderFns } from "./sku_dialog.vue?vue&type=template&id=4980357a&scoped=true"
import script from "./sku_dialog.vue?vue&type=script&lang=js"
export * from "./sku_dialog.vue?vue&type=script&lang=js"
import style0 from "./sku_dialog.vue?vue&type=style&index=0&id=4980357a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4980357a",
  null
  
)

export default component.exports